exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// ./~/deep-equal/lib/keys.js
// module id = 33
// module chunks = 50739212244294 95715928098905 107818501498521 114276838955818 216664578383465